import { parseGiftPassTagText, type GiftPassBundleTag, type GiftPassTagIcon } from '@bonsai/shared';
import {
  Check,
  Clock,
  Flame,
  Gift,
  Heart,
  Leaf,
  Sparkles,
  Star,
  Ticket,
  TreeDeciduous,
  type LucideIcon,
} from 'lucide-react';

import './gift-pass-tag.css';

export const GIFT_PASS_TAG_ICON_GLYPHS: Record<GiftPassTagIcon, LucideIcon> = {
  star: Star,
  heart: Heart,
  flame: Flame,
  sparkles: Sparkles,
  gift: Gift,
  leaf: Leaf,
  tree: TreeDeciduous,
  clock: Clock,
  ticket: Ticket,
  check: Check,
};

export function GiftPassTag({ tag }: { tag: GiftPassBundleTag }) {
  return (
    <span className={`gp-tag gp-tag-${tag.color}`}>
      {parseGiftPassTagText(tag.text).map((part, i) => {
        if (part.kind === 'text') return <span key={i}>{part.text.trim()}</span>;
        const Glyph = GIFT_PASS_TAG_ICON_GLYPHS[part.icon];
        return (
          <Glyph
            key={i}
            size={11}
            strokeWidth={2.5}
            role="img"
            aria-label={part.icon}
            data-icon={part.icon}
          />
        );
      })}
    </span>
  );
}
